import './Filter.scss';
import React, { Component } from 'react';
import FilterTree from './FilterTree';
import { some, find, isObject } from 'lodash';
import Switch from 'react-switch';
import { connect } from 'react-redux';

import { createSelector } from 'reselect';
import actions from '../../../store/appActions';
import { buildDisplayAgents, findAgentFeature } from '../../../utils/agentUtil';

const TRACKS_CONCEPT_URI =
  'https://sensingclues.poolparty.biz/SCCSSOntology/42';

class Filter extends Component {
  //* add scroll to sidebar
  lastTracksFetchSignature = null;
  resizeStartX = 0;
  resizeStartWidth = 0;
  resizing = false;

  state = {
    conceptQuery: [],
    filterList: [],
    excludeList: [],
    expandedList: [],
    searchQuery: '',
    totalConcepts: 0,
    allConceptSelected: false,
    dataSourcesOpen: true,
    agentsOpen: true,
    filtersOpen: true,
    selectedDataSources: [],
    selectedAgents: [],
    mode: true,
    concepts: [],
    showAgentListInfo: false,
    agentListInfoPopoverStyle: null
  };
  filteredOntologyCache = {
    ontology: null,
    searchQuery: '',
    result: {
      list: [],
      totalConcepts: 0,
      hasCountData: false
    }
  };

  componentDidMount() {
    this.restorePanelStateFromStorage();
  }

  componentWillUnmount() {
    this.teardownFilterResize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetVersion !== this.props.resetVersion) {
      this.filteredOntologyCache = {
        ontology: null,
        searchQuery: '',
        result: {
          list: [],
          totalConcepts: 0,
          hasCountData: false
        }
      };
      this.setState({
        conceptQuery: [],
        filterList: [],
        excludeList: [],
        expandedList: [],
        searchQuery: '',
        selectedDataSources: [],
        selectedAgents: [],
        mode: true,
        concepts: [],
        showAgentListInfo: false,
        agentListInfoPopoverStyle: null
      });
    }

    if (prevProps.dataSources !== this.props.dataSources) {
      const availableDataSourceNames = new Set(
        (this.props.dataSources || []).map(item => item.name)
      );
      const nextSelectedDataSources = (
        this.state.selectedDataSources || []
      ).filter(item => availableDataSourceNames.has(item.name));
      if (
        nextSelectedDataSources.length !== this.state.selectedDataSources.length
      ) {
        this.setState({ selectedDataSources: nextSelectedDataSources });
      }
    }

    if (prevProps.agents !== this.props.agents) {
      const availableAgentNames = new Set(
        (this.props.agents || []).map(item => item.name)
      );
      const nextSelectedAgents = (
        this.state.selectedAgents || []
      ).filter(item => availableAgentNames.has(item.name));
      if (nextSelectedAgents.length !== this.state.selectedAgents.length) {
        this.setState({ selectedAgents: nextSelectedAgents });
      }
    }

    if (prevProps.querySelectedAgents !== this.props.querySelectedAgents) {
      const availableAgentNames = new Set(
        (this.props.agents || []).map(item => item.name)
      );
      const nextSelectedAgents = (
        this.props.querySelectedAgents || []
      ).filter(item => availableAgentNames.has(item.name));
      this.setState({ selectedAgents: nextSelectedAgents });
    }

    if (prevProps.querySelectedConcepts !== this.props.querySelectedConcepts) {
      const findNodeById = (nodes, id) => {
        if (!Array.isArray(nodes) || nodes.length === 0) return null;
        const targetId = String(id || '').trim();
        if (!targetId) return null;
        for (let index = 0; index < nodes.length; index += 1) {
          const node = nodes[index];
          const nodeId = String((node && node.id) || '').trim();
          if (nodeId && nodeId === targetId) return node;
          const childHit = findNodeById(node && node.children, targetId);
          if (childHit) return childHit;
        }
        return null;
      };

      const conceptQuery = Array.isArray(this.props.querySelectedConcepts)
        ? this.props.querySelectedConcepts
        : [];
      const filterList = conceptQuery
        .filter(item => typeof item === 'string')
        .map(id => findNodeById(this.props.ontology, id))
        .filter(Boolean);
      const excludeList = conceptQuery
        .filter(item => item && typeof item === 'object' && item.not)
        .map(item => findNodeById(this.props.ontology, item.not))
        .filter(Boolean);
      this.setState({
        conceptQuery,
        filterList,
        excludeList
      });
    }

    if (prevProps.currentUser !== this.props.currentUser) {
      this.restorePanelStateFromStorage();
    }
  }

  getPanelStateStorageKey = panelName => {
    const userKey = this.props.currentUser || 'anonymous';
    return `focus.filter.${panelName}.${userKey}`;
  };

  persistPanelState = (panelName, value) => {
    try {
      localStorage.setItem(
        this.getPanelStateStorageKey(panelName),
        String(value)
      );
    } catch (error) {
      return null;
    }
  };

  restorePanelStateFromStorage = () => {
    try {
      const dataSourcesValue = localStorage.getItem(
        this.getPanelStateStorageKey('dataSourcesOpen')
      );
      const agentsValue = localStorage.getItem(
        this.getPanelStateStorageKey('agentsOpen')
      );
      const nextState = {};
      if (dataSourcesValue !== null) {
        nextState.dataSourcesOpen = dataSourcesValue === 'true';
      }
      if (agentsValue !== null) {
        nextState.agentsOpen = agentsValue === 'true';
      }
      if (Object.keys(nextState).length > 0) {
        this.setState(nextState);
      }
    } catch (error) {
      return null;
    }
  };

  grabFilterList = async selectedNode => {
    const { filterList, excludeList, conceptQuery } = this.state;
    let conceptsList = [];
    let match = find(filterList, { id: selectedNode.id });
    if (!match) {
      this.setState({ filterList: filterList.concat(selectedNode) });
      conceptsList = [...conceptQuery, selectedNode.id];
    } else {
      let filtered = filterList.filter(node => {
        return node.id !== selectedNode.id;
      });

      conceptsList = conceptQuery.filter(item => {
        if (!isObject(item)) {
          return item !== selectedNode.id;
        }
        return false;
      });

      this.setState({ filterList: filtered });
    }

    let matchInExcludeList = find(excludeList, { id: selectedNode.id });
    if (matchInExcludeList) {
      let newExcludeList = excludeList.filter(node => {
        return node.id !== selectedNode.id;
      });
      this.setState({ excludeList: newExcludeList });

      conceptsList = conceptsList.filter(item => {
        if (isObject(item)) {
          return item.not !== selectedNode.id;
        }
        return true;
      });
    }

    await this.setState({ conceptQuery: conceptsList });
    this.setConcepts(this.state.conceptQuery);
  };

  grabExcludeNode = async selectedNode => {
    const { filterList, excludeList, conceptQuery } = this.state;
    if (selectedNode) {
      let conceptsList = [];

      let match = find(excludeList, { id: selectedNode.id });
      if (!match) {
        this.setState({
          excludeList: this.state.excludeList.concat(selectedNode)
        });

        //* Create a singleton
        let exclude = new (function() {
          this.not = selectedNode.id;
        })();

        if (exclude.not) {
          conceptsList = [...this.state.conceptQuery, exclude];
        }
      } else {
        let filtered = excludeList.filter(node => node.id !== selectedNode.id);

        conceptsList = conceptQuery.filter(item => {
          if (isObject(item)) {
            return item.not !== selectedNode.id;
          }
          return true;
        });

        this.setState({ excludeList: filtered });
      }

      let matchInFilterList = find(filterList, { id: selectedNode.id });
      if (matchInFilterList) {
        let newFilterList = filterList.filter(node => {
          return node.id !== selectedNode.id;
        });
        this.setState({ filterList: newFilterList });

        conceptsList = conceptsList.filter(item => {
          if (!isObject(item)) {
            return item !== selectedNode.id;
          }
          return true;
        });
      }

      await this.setState({ conceptQuery: conceptsList });
      this.setConcepts(this.state.conceptQuery);
    }
  };

  grabExpandedNodes = async node => {
    if (node && this.state.expandedList.some(value => value.id === node.id)) {
      this.setState({
        expandedList: this.state.expandedList.filter(
          value => value.id !== node.id
        )
      });
    } else {
      if (node !== null)
        await this.setState({
          expandedList: [...this.state.expandedList, node]
        });
    }
  };

  handleChange = event => {
    this.setState({ searchQuery: event.target.value });
  };

  clearSelectedMapResultIfNeeded = () => {
    const selectedItem = this.props.selectedItem || {};
    const selectedEntityType = String(
      (selectedItem.properties && selectedItem.properties.EntityType) || ''
    ).toLowerCase();
    const hasSelectedObservation = Boolean(
      selectedItem.observationId ||
        selectedItem.ObservationId ||
        selectedItem.EntityId
    );
    const hasSelectedTrack = Boolean(
      selectedItem.featureId || selectedEntityType.indexOf('track') === 0
    );
    if (hasSelectedObservation || hasSelectedTrack) {
      this.props.clearSelectedItem();
    }
  };

  filterListOnCountAndQuery(array, searchString) {
    let results = [];
    let totalConceptsWithoutSearch = 0;
    let totalConceptsWithSearch = 0;
    const sourceList = Array.isArray(array) ? array : [];
    const getNodeCount = node => {
      const direct = Number(node && node.count);
      if (Number.isFinite(direct) && direct > 0) return direct;
      const label = String((node && node.label) || '');
      const match = label.match(/\((\d+)\)\s*$/);
      if (!match) return 0;
      const fromLabel = Number(match[1]);
      return Number.isFinite(fromLabel) && fromLabel > 0 ? fromLabel : 0;
    };

    const hasAnyCount = nodes =>
      nodes.some(node => {
        const ownCount = getNodeCount(node);
        if (ownCount > 0) return true;
        if (Array.isArray(node && node.children) && node.children.length > 0) {
          return hasAnyCount(node.children);
        }
        return false;
      });

    const removeAllWithoutCount = (result, object) => {
      const ownCount = getNodeCount(object);
      const childNodes = Array.isArray(object.children)
        ? object.children.reduce(removeAllWithoutCount, [])
        : [];
      const includeNode = ownCount > 0 || childNodes.length > 0;

      if (includeNode) {
        if (childNodes.length > 0) {
          totalConceptsWithoutSearch = totalConceptsWithoutSearch + 1;
          result.push({ ...object, children: childNodes });
        } else {
          totalConceptsWithoutSearch = totalConceptsWithoutSearch + 1;
          const nextNode = { ...object };
          delete nextNode.children;
          result.push(nextNode);
        }
      }

      return result;
    };

    const hasCountData = hasAnyCount(sourceList);

    // Remove all concepts without count; without count data, keep this list empty.
    if (hasCountData) {
      results = sourceList.reduce(removeAllWithoutCount, []);
    }

    const matchSearchQuery = (result, object) => {
      if (Array.isArray(object.children) && object.children.length) {
        const nodes = object.children.reduce(matchSearchQuery, []);
        if (
          nodes.length > 0 ||
          object.label.toLowerCase().includes(searchString.toLowerCase())
        ) {
          totalConceptsWithSearch = totalConceptsWithSearch + 1;
          result.push({ ...object, children: nodes });
        }
      } else {
        if (object.label.toLowerCase().includes(searchString.toLowerCase())) {
          totalConceptsWithSearch = totalConceptsWithSearch + 1;
          result.push(object);
        }
      }

      return result;
    };

    // Remove all concepts that do not match search query
    if (searchString.length > 0) results = results.reduce(matchSearchQuery, []);

    return {
      list: results,
      totalConcepts:
        searchString.length > 0
          ? totalConceptsWithSearch
          : totalConceptsWithoutSearch,
      hasCountData
    };
  }

  getFilteredFilterList = (ontology, searchQuery) => {
    const cached = this.filteredOntologyCache;
    if (cached.ontology === ontology && cached.searchQuery === searchQuery) {
      return cached.result;
    }

    const result = this.filterListOnCountAndQuery(ontology, searchQuery);

    this.filteredOntologyCache = {
      ontology,
      searchQuery,
      result
    };
    return result;
  };

  removeFromIncludeList = async id => {
    await this.setState({
      filterList: this.state.filterList.filter(item => item.id !== id),
      conceptQuery: this.state.conceptQuery.filter(item => {
        if (isObject(item)) {
          return true;
        } else {
          return item !== id;
        }
      })
    });
    this.setConcepts(this.state.conceptQuery);
  };

  removeFromExcludeList = async id => {
    await this.setState({
      excludeList: this.state.excludeList.filter(item => item.id !== id),
      conceptQuery: this.state.conceptQuery.filter(item => {
        if (isObject(item)) {
          return item.not !== id;
        } else {
          return true;
        }
      })
    });
    this.setConcepts(this.state.conceptQuery);
  };

  collapseDataSources = () => {
    this.setState(
      prevState => ({ dataSourcesOpen: !prevState.dataSourcesOpen }),
      () =>
        this.persistPanelState('dataSourcesOpen', this.state.dataSourcesOpen)
    );
  };

  collapseAgents = () => {
    this.setState(
      prevState => ({ agentsOpen: !prevState.agentsOpen }),
      () => this.persistPanelState('agentsOpen', this.state.agentsOpen)
    );
  };

  toggleAgentListInfo = e => {
    e.preventDefault();
    e.stopPropagation();
    const buttonElement = e.currentTarget;
    const hasRectMethod =
      buttonElement &&
      typeof buttonElement.getBoundingClientRect === 'function';
    const rect = hasRectMethod ? buttonElement.getBoundingClientRect() : null;
    const popoverStyle = rect
      ? {
          top: `${rect.top}px`,
          left: `${rect.right + 8}px`
        }
      : null;
    this.setState(prevState => {
      if (prevState.showAgentListInfo) {
        return {
          showAgentListInfo: false,
          agentListInfoPopoverStyle: null
        };
      }
      return {
        showAgentListInfo: true,
        agentListInfoPopoverStyle: popoverStyle
      };
    });
  };

  collapseFilters = () => {
    if (this.state.filtersOpen) {
      this.setState({ filtersOpen: false });
    } else {
      this.setState({ filtersOpen: true });
    }
  };

  startFilterResize = e => {
    if (this.props.isMobile || this.props.filterCollapsed) return;
    e.preventDefault();
    e.stopPropagation();
    const panel = document.getElementById('filter');
    const panelRect = panel ? panel.getBoundingClientRect() : null;
    const startWidth =
      panelRect && Number.isFinite(panelRect.width)
        ? panelRect.width
        : Number(this.props.filterPanelWidthPx) || 0;
    this.resizeStartX = e.clientX;
    this.resizeStartWidth = startWidth;
    this.resizing = true;
    document.body.classList.add('filter-resizing');
    window.addEventListener('mousemove', this.handleFilterResizeMove);
    window.addEventListener('mouseup', this.handleFilterResizeEnd);
  };

  handleFilterResizeMove = e => {
    if (!this.resizing) return;
    const deltaX = e.clientX - this.resizeStartX;
    const nextWidth = this.resizeStartWidth + deltaX;
    if (this.props.onFilterPanelResize) {
      this.props.onFilterPanelResize(nextWidth);
    }
  };

  handleFilterResizeEnd = () => {
    this.teardownFilterResize();
  };

  teardownFilterResize = () => {
    if (!this.resizing) return;
    this.resizing = false;
    document.body.classList.remove('filter-resizing');
    window.removeEventListener('mousemove', this.handleFilterResizeMove);
    window.removeEventListener('mouseup', this.handleFilterResizeEnd);
  };

  refreshAfterFilterChange = async () => {
    // Run one synchronized refresh path so map, counts and timeline stay aligned.
    await Promise.resolve(this.props.fetchAllData());
  };

  checkDataSource = async value => {
    const sourceName = value.name;
    const hasIncluded = this.state.selectedDataSources.some(
      item => item.name === sourceName && !item.not
    );
    let newDataSources = this.state.selectedDataSources.filter(
      item => item.name !== sourceName
    );

    if (!hasIncluded) {
      newDataSources = [...newDataSources, value];
    }

    await this.props.setSelectedDataSources(newDataSources);
    await this.setState({
      selectedDataSources: newDataSources
    });

    await this.refreshAfterFilterChange();
  };

  checkDataSourceExclude = async value => {
    const sourceName = value.name;
    const hasExcluded = this.state.selectedDataSources.some(
      item => item.name === sourceName && !!item.not
    );
    let newDataSources = this.state.selectedDataSources.filter(
      item => item.name !== sourceName
    );

    if (!hasExcluded) {
      newDataSources = [
        ...newDataSources,
        {
          ...value,
          not: sourceName
        }
      ];
    }

    await this.props.setSelectedDataSources(newDataSources);
    await this.setState({
      selectedDataSources: newDataSources
    });
    await this.refreshAfterFilterChange();
  };

  checkAllDataSources = async () => {
    const includedDataSources = this.state.selectedDataSources.filter(
      item => !item.not
    );
    if (includedDataSources.length === this.props.dataSources.length) {
      await this.props.setSelectedDataSources([]);
      await this.setState({
        selectedDataSources: []
      });
    } else {
      await this.props.setSelectedDataSources(this.props.dataSources);
      await this.setState({
        selectedDataSources: this.props.dataSources
      });
    }

    await this.refreshAfterFilterChange();
  };

  checkAgent = async value => {
    if (some(this.state.selectedAgents, ['name', value.name])) {
      let newAgents = this.state.selectedAgents.filter(
        item => item.name !== value.name
      );
      await this.props.setSelectedAgents(newAgents);
      await this.setState({
        selectedAgents: newAgents
      });
    } else {
      let newAgents = [...this.state.selectedAgents, value];
      await this.props.setSelectedAgents(newAgents);
      await this.setState({
        selectedAgents: newAgents
      });
    }
    await this.refreshAfterFilterChange();
  };
  checkAllAgents = async () => {
    if (this.state.selectedAgents.length === this.props.agents.length) {
      await this.props.setSelectedAgents([]);
      await this.setState({
        selectedAgents: []
      });
    } else {
      await this.props.setSelectedAgents(this.props.agents);
      await this.setState({
        selectedAgents: this.props.agents
      });
    }
    await this.refreshAfterFilterChange();
  };
  zoomToAgent = (e, facet) => {
    e.preventDefault();
    e.stopPropagation();
    const feature = this.getAgentFeature(facet);
    if (!feature || !feature.geometry || !feature.geometry.coordinates) return;
    window.dispatchEvent(
      new CustomEvent('focus:zoom-to-agent', {
        detail: {
          coordinates: feature.geometry.coordinates,
          entityId:
            feature.properties && feature.properties.EntityId
              ? String(feature.properties.EntityId)
              : null,
          name: String(facet.displayLabel || facet.value || facet.name || ''),
          feature
        }
      })
    );
  };

  showTracksForAgent = async (e, facet) => {
    e.preventDefault();
    e.stopPropagation();
    const loadingStartedAt = Date.now();
    const agentName = String(
      facet.displayLabel || facet.value || facet.name || ''
    );
    const matchValues = Array.from(this.getFacetAgentMatchValues(facet));
    const conceptTrackCount = this.getConceptTrackCount();
    const expectedTrackCount =
      Number.isFinite(conceptTrackCount) && conceptTrackCount > 0
        ? conceptTrackCount
        : this.getLoadedTracksCountForAgent(facet);
    window.dispatchEvent(
      new CustomEvent('focus:show-all-tracks-for-agent', {
        detail: {
          agentName,
          matchValues,
          expectedTrackCount,
          focusContext: {
            north: this.props.queryNorth,
            east: this.props.queryEast,
            south: this.props.querySouth,
            west: this.props.queryWest,
            start: this.props.queryStart,
            end: this.props.queryEnd,
            selectedLayersBeforeFocus: Array.isArray(this.props.selectedLayers)
              ? [...this.props.selectedLayers]
              : []
          }
        }
      })
    );
    if (this.props.setTransientLoading) {
      this.props.setTransientLoading(true, 'Loading all track traces...');
    }
    try {
      await this.props.setSelectedAgents([facet]);
      await this.setState({
        selectedAgents: [facet]
      });
      await this.props.getTimeline(false);
      const selectedLayers = Array.isArray(this.props.selectedLayers)
        ? this.props.selectedLayers
        : [];
      const focusedSelectedLayers = Array.from(
        new Set(
          selectedLayers
            .filter(layerName => layerName !== 'Observations')
            .concat('Tracks')
        )
      );
      await this.props.setSelectedLayers(focusedSelectedLayers);
      const fetchSignature = this.getTracksFetchSignature(facet);
      await this.props.getTracksForCurrentFilters();
      this.lastTracksFetchSignature = fetchSignature;
      window.dispatchEvent(new CustomEvent('focus:zoom-to-track-bounds'));
      await new Promise(resolve => setTimeout(resolve, 450));
    } finally {
      const elapsedMs = Date.now() - loadingStartedAt;
      if (elapsedMs < 300) {
        await new Promise(resolve => setTimeout(resolve, 300 - elapsedMs));
      }
    }
  };

  normalizeCompareValue = value =>
    (value || '')
      .toString()
      .trim()
      .toLowerCase();

  getFacetAgentMatchValues = facet => {
    const values = [];
    const agentFeature = this.getAgentFeature(facet);
    const props = (agentFeature && agentFeature.properties) || {};
    [
      facet && facet.name,
      facet && facet.value,
      facet && facet.displayLabel,
      props.EntityId,
      props.AgentId,
      props.Name,
      props.AgentName,
      props.EntityName
    ].forEach(value => {
      const normalized = this.normalizeCompareValue(value);
      if (normalized) values.push(normalized);
    });
    return new Set(values);
  };

  getLoadedTracksCountForAgent = facet => {
    const matchValues = this.getFacetAgentMatchValues(facet);
    if (!matchValues.size) return 0;
    const agentFeature = this.getAgentFeature(facet);
    const agentProps = (agentFeature && agentFeature.properties) || {};
    const featureTrackCount = Number(
      agentProps.trackCount ||
        agentProps.TrackCount ||
        agentProps.tracksCount ||
        agentProps.TracksCount ||
        0
    );

    const trackFeatures = Array.isArray(this.props.trackFeatures)
      ? this.props.trackFeatures
      : [];
    const uniqueTrackIdsFromMap = new Set();
    trackFeatures.forEach(feature => {
      const props = (feature && feature.properties) || {};
      const trackId =
        props.EntityId || props.featureId || props.trackId || feature.id;
      if (trackId) uniqueTrackIdsFromMap.add(String(trackId));
    });

    const selectedAgents = Array.isArray(this.props.querySelectedAgents)
      ? this.props.querySelectedAgents
      : [];
    if (selectedAgents.length === 1 && uniqueTrackIdsFromMap.size > 0) {
      const selectedAgent = selectedAgents[0] || {};
      const selectedMatchValues = new Set(
        [
          selectedAgent.name,
          selectedAgent.value,
          selectedAgent.displayLabel,
          selectedAgent.id,
          selectedAgent.EntityId,
          selectedAgent.agentId
        ]
          .map(value => this.normalizeCompareValue(value))
          .filter(Boolean)
      );
      const facetMatchesSelected = Array.from(matchValues).some(value =>
        selectedMatchValues.has(value)
      );
      if (facetMatchesSelected) {
        return uniqueTrackIdsFromMap.size;
      }
    }
    if (uniqueTrackIdsFromMap.size > 0) {
      const isFacetSelected = (this.state.selectedAgents || []).some(
        agent =>
          this.normalizeCompareValue(agent && agent.name) ===
            this.normalizeCompareValue(facet && facet.name) ||
          this.normalizeCompareValue(agent && agent.value) ===
            this.normalizeCompareValue(facet && facet.value)
      );
      if (isFacetSelected) {
        return uniqueTrackIdsFromMap.size;
      }
    }

    const trackIds = new Set();

    trackFeatures.forEach(feature => {
      const props = (feature && feature.properties) || {};
      const nestedAgent = props.agent || {};
      const directAgent = (feature && feature.agent) || {};
      const candidates = [
        props.AgentId,
        props.agentId,
        props.AgentRef,
        props.agentRef,
        props.AgentName,
        props.agentName,
        props.Name,
        props.name,
        props.EntityName,
        nestedAgent.agentId,
        nestedAgent.agentName,
        nestedAgent.agentRef,
        directAgent.agentId,
        directAgent.agentName,
        directAgent.agentRef,
        feature && feature.agentRef
      ];
      const matches = candidates.some(candidate =>
        matchValues.has(this.normalizeCompareValue(candidate))
      );
      if (!matches) return;
      const trackId =
        props.EntityId || props.featureId || props.trackId || feature.id;
      if (trackId) trackIds.add(String(trackId));
    });

    if (trackIds.size > 0) return trackIds.size;

    const timelineResults = Array.isArray(this.props.timelineResults)
      ? this.props.timelineResults
      : [];
    timelineResults.forEach(item => {
      const content = item && item.extracted && item.extracted.content;
      if (!Array.isArray(content)) return;
      const geoFeatureEntry = content.find(entry => entry && entry.GeoFeature);
      if (!geoFeatureEntry || !geoFeatureEntry.GeoFeature) return;
      const geoFeature = geoFeatureEntry.GeoFeature;
      const featureType = this.normalizeCompareValue(geoFeature.featureType);
      if (!featureType.startsWith('track/')) return;
      const agent = geoFeature.agent || {};
      const candidates = [
        agent.agentId,
        agent.agentName,
        agent.agentRef,
        geoFeature.agentId,
        geoFeature.agentName,
        geoFeature.agentRef
      ];
      const matches = candidates.some(candidate =>
        matchValues.has(this.normalizeCompareValue(candidate))
      );
      if (!matches) return;
      const trackId =
        geoFeature.featureId || geoFeature.EntityId || geoFeature.trackId;
      if (trackId) trackIds.add(String(trackId));
    });

    if (trackIds.size > 0) return trackIds.size;
    if (featureTrackCount > 0) return featureTrackCount;
    return 0;
  };

  getConceptTrackCount = () => {
    const normalizeToken = value =>
      String(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');
    const toNumber = value => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const countFromLabel = label => {
      const text = String(label || '');
      const match = text.match(/\((\d+)\)\s*$/);
      return match ? toNumber(match[1]) : 0;
    };
    const resolveNodeCount = node => {
      if (!node || typeof node !== 'object') return 0;
      const direct = toNumber(node.count);
      if (direct > 0) return direct;
      return countFromLabel(node.label);
    };
    const nodeTokens = node =>
      [
        node && node.uri,
        node && node.URI,
        node && node.id,
        node && node.key,
        node && node.value,
        node && node.name,
        node && node.label
      ]
        .map(normalizeToken)
        .filter(Boolean);
    const tokenMatchesTrackCategory = token => {
      const normalized = normalizeToken(token);
      if (!normalized) return false;
      return (
        normalized === 'track' ||
        normalized === 'tracks' ||
        normalized.endsWith('track') ||
        normalized.endsWith('tracks')
      );
    };
    const searchTree = (nodes, predicate) => {
      const list = Array.isArray(nodes) ? nodes : [];
      for (let index = 0; index < list.length; index += 1) {
        const node = list[index];
        if (predicate(node)) return node;
        const childHit = searchTree(node && node.children, predicate);
        if (childHit) return childHit;
      }
      return null;
    };

    const ontology = Array.isArray(this.props.ontology)
      ? this.props.ontology
      : [];
    const tracksNodeByUri = searchTree(ontology, node => {
      const uri = String((node && (node.uri || node.URI || node.id)) || '')
        .trim()
        .toLowerCase();
      return uri === TRACKS_CONCEPT_URI.toLowerCase();
    });
    if (tracksNodeByUri) {
      return resolveNodeCount(tracksNodeByUri);
    }

    const tracksNode = searchTree(ontology, node =>
      nodeTokens(node).some(tokenMatchesTrackCategory)
    );
    return resolveNodeCount(tracksNode);
  };

  getTracksFetchSignature = facet => {
    const feature = this.getAgentFeature(facet);
    const props = (feature && feature.properties) || {};
    const agentKey =
      props.EntityId ||
      props.AgentId ||
      facet.name ||
      facet.value ||
      facet.displayLabel ||
      '';
    return JSON.stringify({
      agent: String(agentKey),
      north: this.props.queryNorth,
      east: this.props.queryEast,
      south: this.props.querySouth,
      west: this.props.queryWest,
      start: this.props.queryStart,
      end: this.props.queryEnd
    });
  };

  formatLastSeen = value => {
    if (!value) return null;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    if (date > new Date()) return null;
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ];
    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day} ${month} ${year} - ${hours}:${minutes}`;
  };

  // Joined on EntityId by findAgentFeature. This used to compare the facet
  // value against the feature's Name, i.e. an id against a username, so it
  // never matched - which is why the last-seen timestamp and the zoom button
  // did not appear for any agent.
  getAgentFeature = facet => findAgentFeature(facet, this.props.agentFeatures);

  changeMode = async value => {
    await this.props.setMode(value);
    await this.setState({ mode: value });
    await this.refreshAfterFilterChange();
  };

  setConcepts = async data => {
    await this.props.setSelectedConcepts(data);
    await this.setState({
      concepts: data
    });
    await this.refreshAfterFilterChange();
  };

  render() {
    const { filterList, excludeList, searchQuery } = this.state;
    const { ontology } = this.props;
    const visibleAgents = this.props.agents;
    const selectedIncludedDataSources = this.state.selectedDataSources.filter(
      item => !item.not
    );
    const selectedVisibleAgents = this.state.selectedAgents.filter(agent =>
      visibleAgents.some(item => item.name === agent.name)
    );

    const currentLoadingStep = String(
      (this.props.dataLoading && this.props.dataLoading.current) || ''
    )
      .trim()
      .toLowerCase();
    const isConceptTreeLoading =
      this.props.ontologyLoading ||
      (this.props.dataLoading &&
        this.props.dataLoading.inFlight &&
        (currentLoadingStep === 'concept counts' ||
          currentLoadingStep === 'results'));
    let filteredFilterList = this.getFilteredFilterList(ontology, searchQuery);
    const shouldShowConceptLoading =
      isConceptTreeLoading ||
      (this.props.dataLoading &&
        this.props.dataLoading.inFlight &&
        !filteredFilterList.hasCountData);
    const hasConcepts = filteredFilterList.totalConcepts > 0;
    const baseClass = this.props.filterCollapsed
      ? 'px-0 col-0 filter no-scroll'
      : !this.props.filterExpanded
      ? 'px-0 col-2 filter'
      : 'px-0 col-3 filter';
    const hasCustomDesktopWidth =
      !this.props.isMobile &&
      !this.props.filterCollapsed &&
      Number.isFinite(Number(this.props.filterPanelWidthPx));
    const rootStyle = hasCustomDesktopWidth
      ? {
          width: `${this.props.filterPanelWidthPx}px`,
          minWidth: `${this.props.filterResizeMinPx || 220}px`,
          maxWidth: `${this.props.filterResizeMaxPx || 520}px`,
          flex: `0 0 ${this.props.filterPanelWidthPx}px`
        }
      : undefined;
    const panelClassName =
      baseClass +
      (this.props.isMobile ? ' mobile-pane' : '') +
      (this.props.isMobile && !this.props.mobileActive
        ? ' mobile-pane-hidden'
        : '');

    return (
      <div
        id="filter"
        className={panelClassName}
        style={rootStyle}
        onMouseDownCapture={this.clearSelectedMapResultIfNeeded}
      >
        {!this.props.filterCollapsed && (
          <div id="accordion">
            <div className="card rounded-0 border-bottom-0">
              <div
                className="card-header"
                id="headingOne"
                onClick={e => {
                  if (e.target && e.target.closest('button')) return;
                  this.collapseFilters();
                }}
              >
                <h6 className="mb-0" style={{ float: 'left' }}>
                  Filters
                </h6>
                <div
                  className={
                    this.state.filtersOpen
                      ? `super-treeview-triangle-btn-down`
                      : `super-treeview-triangle-btn-up`
                  }
                />
              </div>

              {this.state.filtersOpen && (
                <div>
                  {hasConcepts && (
                    <form onSubmit={e => e.preventDefault()}>
                      <div className="row mt-2">
                        <div className="col">
                          <ul className="list-group list-group-flush">
                            <li className="list-group-item border-0">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Find concepts"
                                value={this.state.searchQuery}
                                onSubmit={this.prevent}
                                onChange={this.handleChange}
                              />
                            </li>
                            <li className="list-group-item border-0 switch-container">
                              <div className="row no-negative-margin">
                                <label
                                  htmlFor=""
                                  className="text-muted and-label"
                                >
                                  AND
                                </label>
                                <label
                                  htmlFor=""
                                  className="font-weight-light m-0 p-0 mt-1 switch-label"
                                >
                                  <Switch
                                    height={18}
                                    width={36}
                                    onChange={this.changeMode}
                                    checked={this.state.mode}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                  />
                                </label>
                                <label
                                  htmlFor=""
                                  className="text-muted or-label"
                                >
                                  OR
                                </label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </form>
                  )}

                  <div className="list-group px-3">
                    <div>
                      {filterList.map(node => {
                        return (
                          <button
                            key={node.id}
                            type="button"
                            className="btn btn-outline-success btn-sm ml-1 mt-1"
                          >
                            <span key={node.id}>{node.label}</span>
                            <svg
                              width="1em"
                              height="1em"
                              viewBox="0 0 16 16"
                              className="bi bi-x"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={() =>
                                this.removeFromIncludeList(node.id)
                              }
                            >
                              <path
                                fillRule="evenodd"
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                              ></path>
                            </svg>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div className="list-group px-3">
                    <div>
                      {excludeList.map(node => {
                        return (
                          <button
                            type="button"
                            key={node.id}
                            className="btn btn-outline-danger btn-sm ml-1 mt-1"
                          >
                            <span key={node.id}>{node.label}</span>
                            <svg
                              width="1em"
                              height="1em"
                              viewBox="0 0 16 16"
                              className="bi bi-x"
                              fill="currentColor"
                              xmlns="http://www.w3.org/2000/svg"
                              onClick={() =>
                                this.removeFromExcludeList(node.id)
                              }
                            >
                              <path
                                fillRule="evenodd"
                                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                              ></path>
                            </svg>
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body px-0 pt-1">
                      <div className="list-group list-group-flush">
                        <div className="list-group-item border-0 mt-0 py-0">
                          <div className="custom-control pl-3">
                            <label className="text-muted"></label>
                            <label className="text-muted float-right small">
                              {`${this.state.filterList.length +
                                this.state.excludeList.length} of ${
                                filteredFilterList.totalConcepts
                              }`}{' '}
                              selected
                            </label>
                            {hasConcepts ? (
                              <FilterTree
                                ontology={filteredFilterList.list}
                                includeList={this.state.filterList}
                                excludeList={this.state.excludeList}
                                expandedList={this.state.expandedList}
                                bubbleUpFilterList={value =>
                                  this.grabFilterList(value)
                                }
                                bubbleUpExcludeNode={value =>
                                  this.grabExcludeNode(value)
                                }
                                bubbleUpExpandedNodes={value =>
                                  this.grabExpandedNodes(value)
                                }
                              />
                            ) : shouldShowConceptLoading ? (
                              <div className="concepts-loading-placeholder">
                                Loading concepts...
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="card rounded-0 border-bottom-0">
              <div
                className="card-header"
                id="headingTwo"
                onClick={() => this.collapseDataSources()}
              >
                <h6 className="mb-0" style={{ float: 'left' }}>
                  Data sources ({this.props.dataSources.length})
                </h6>
                <div
                  className={
                    this.state.dataSourcesOpen
                      ? `super-treeview-triangle-btn-down`
                      : `super-treeview-triangle-btn-up`
                  }
                />
              </div>

              {this.state.dataSourcesOpen && (
                <div>
                  <div
                    id="collapseTwo"
                    className="collapse show"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body facets">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item border-0 mt-0 py-0">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="allFacets"
                            onChange={() => this.checkAllDataSources()}
                            checked={this.props.dataSources
                              .map(item => item.name)
                              .every(val => {
                                return (
                                  selectedIncludedDataSources
                                    .map(item => item.name)
                                    .indexOf(val) >= 0
                                );
                              })}
                          />
                          <label className="text-muted" htmlFor="allFacets">
                            All
                          </label>
                          <label className="text-muted float-right small">
                            {selectedIncludedDataSources.length} of{' '}
                            {this.props.dataSources.length}
                          </label>
                        </li>
                        {this.props.dataSources.map(facet => {
                          return (
                            <li
                              className="list-group-item border-0 mt-0 py-0"
                              key={facet.name}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={facet.name}
                                onChange={() => this.checkDataSource(facet)}
                                checked={this.state.selectedDataSources.some(
                                  item => item.name === facet.name && !item.not
                                )}
                              />
                              <div className="agent-row">
                                <label className="" htmlFor={facet.name}>
                                  {facet.value} ({facet.count})
                                </label>
                                <button
                                  type="button"
                                  className="agent-zoom-btn"
                                  onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    this.checkDataSourceExclude(facet);
                                  }}
                                  aria-label={`Exclude ${facet.value}`}
                                  title={`Exclude ${facet.value}`}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                    width="14"
                                    height="14"
                                    fill="currentColor"
                                  >
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 1 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                  </svg>
                                </button>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="card rounded-0 border-bottom-0">
              <div
                className="card-header"
                id="headingTwo"
                onClick={() => this.collapseAgents()}
              >
                <h6 className="mb-0 agent-list-title" style={{ float: 'left' }}>
                  <span>Agent list ({visibleAgents.length})</span>
                </h6>
                <div className="agent-list-header-actions">
                  <div
                    className={
                      this.state.agentsOpen
                        ? `super-treeview-triangle-btn-down`
                        : `super-treeview-triangle-btn-up`
                    }
                  />
                </div>
              </div>
              {this.state.agentsOpen && (
                <div>
                  <div
                    id="collapseTwo"
                    className="collapse show"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body facets">
                      <ul className="list-group list-group-flush">
                        <li className="list-group-item border-0 mt-0 py-0">
                          {/* <div className="custom-control custom-checkbox"> */}
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="allAgents"
                            onChange={() => this.checkAllAgents()}
                            checked={this.props.agents
                              .map(item => item.name)
                              .every(val => {
                                return (
                                  this.state.selectedAgents
                                    .map(item => item.name)
                                    .indexOf(val) >= 0
                                );
                              })}
                          />
                          <label className="text-muted" htmlFor="allAgents">
                            All
                          </label>
                          <label className="text-muted float-right small">
                            {selectedVisibleAgents.length} of{' '}
                            {visibleAgents.length}
                          </label>
                          {/* </div> */}
                        </li>
                        {visibleAgents.map(facet => {
                          const agentFeature = this.getAgentFeature(facet);
                          const coordinates =
                            agentFeature &&
                            agentFeature.geometry &&
                            agentFeature.geometry.coordinates;
                          const hasLocation =
                            Array.isArray(coordinates) &&
                            coordinates.length >= 2 &&
                            Number.isFinite(Number(coordinates[0])) &&
                            Number.isFinite(Number(coordinates[1]));
                          const lastSeen =
                            agentFeature &&
                            agentFeature.properties &&
                            agentFeature.properties.LastSeenDateTime;
                          const lastSeenLabel = this.formatLastSeen(lastSeen);
                          const trackCountForAgent = this.getLoadedTracksCountForAgent(
                            facet
                          );
                          return (
                            <li
                              className="list-group-item border-0 mt-0 py-0"
                              key={facet.value || facet.name}
                            >
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={facet.name}
                                onChange={() => this.checkAgent(facet)}
                                checked={some(this.state.selectedAgents, [
                                  'name',
                                  facet.name
                                ])}
                              />
                              <div className="agent-row">
                                <label className="" htmlFor={facet.name}>
                                  {facet.displayLabel || facet.value} (
                                  {facet.count})
                                </label>
                                {Number(this.props.filterPanelWidthPx) >= 300 &&
                                  lastSeenLabel && (
                                    <span className="agent-last-seen">
                                      {lastSeenLabel}
                                    </span>
                                  )}
                                <span className="agent-actions">
                                  {/* Temporarily hidden in UI; keep code intact for later. */}
                                  {false && trackCountForAgent > 0 && (
                                    <button
                                      type="button"
                                      className="agent-tracks-btn"
                                      onClick={e =>
                                        this.showTracksForAgent(e, facet)
                                      }
                                      aria-label={`Show all tracks of ${facet.displayLabel ||
                                        facet.value}`}
                                      title={`Show all tracks of ${facet.displayLabel ||
                                        facet.value}`}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <circle cx="5" cy="18" r="2" />
                                        <circle cx="12" cy="6" r="2" />
                                        <circle cx="19" cy="14" r="2" />
                                        <path d="M6.8 16.9l3.4-8.3" />
                                        <path d="M13.9 7.2l3.3 5.6" />
                                      </svg>
                                    </button>
                                  )}
                                  {hasLocation && (
                                    <button
                                      type="button"
                                      className="agent-zoom-btn"
                                      onClick={e => this.zoomToAgent(e, facet)}
                                      aria-label={`Zoom to ${facet.displayLabel ||
                                        facet.value}`}
                                      title={
                                        lastSeenLabel
                                          ? `Zoom to • Last seen ${lastSeenLabel}`
                                          : 'Zoom to'
                                      }
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        width="16"
                                        height="16"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      >
                                        <circle cx="12" cy="12" r="7" />
                                        <circle cx="12" cy="12" r="2" />
                                        <line x1="12" y1="3" x2="12" y2="6" />
                                        <line x1="12" y1="18" x2="12" y2="21" />
                                        <line x1="3" y1="12" x2="6" y2="12" />
                                        <line x1="18" y1="12" x2="21" y2="12" />
                                      </svg>
                                    </button>
                                  )}
                                </span>
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {!this.props.isMobile && !this.props.filterCollapsed && (
          <button
            type="button"
            className="filter-resize-handle"
            aria-label="Resize filters panel"
            title="Drag to resize filters panel"
            onMouseDown={this.startFilterResize}
          />
        )}
      </div>
    );
  }
}

// Stable fallbacks so input selectors never return a new reference for an
// unchanged state slice — required to keep reselect's stability check quiet.
const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

const getOntology = state => state.ontology.ontology || EMPTY_ARRAY;
const getDataSources = state => state.timeline.dataSources || EMPTY_ARRAY;
const getAgents = state => state.timeline.agents || EMPTY_ARRAY;
const getAgentRegistry = state =>
  (state.agentRegistry && state.agentRegistry.byId) || EMPTY_OBJECT;
const getShowInactiveAgents = state =>
  state.ontology.showInactiveAgents || false;
const getCurrentUser = state => state.user.currentUser || null;
const getAgentLayerFeatures = state => {
  const agentsLayer = (state.layer.layers || EMPTY_ARRAY).find(
    layer => layer.name === 'Agents'
  );
  return agentsLayer && agentsLayer.features
    ? agentsLayer.features
    : EMPTY_ARRAY;
};
// Memoized so that the combined array is only rebuilt when the underlying
// layer references change, preventing a new reference on every selector call.
const getTrackLayerFeatures = createSelector(
  state => state.layer.trackLayer,
  state =>
    (state.layer.layers || EMPTY_ARRAY).find(
      layer => layer && layer.name === 'Tracks'
    ),
  (trackLayer, tracksMapLayer) => {
    const selectedTrackLayerFeatures =
      trackLayer && Array.isArray(trackLayer.features)
        ? trackLayer.features
        : EMPTY_ARRAY;
    const mapLayerTrackFeatures =
      tracksMapLayer && Array.isArray(tracksMapLayer.features)
        ? tracksMapLayer.features
        : EMPTY_ARRAY;
    if (!selectedTrackLayerFeatures.length) return mapLayerTrackFeatures;
    if (!mapLayerTrackFeatures.length) return selectedTrackLayerFeatures;

    const combined = [];
    const seenIds = new Set();
    [...selectedTrackLayerFeatures, ...mapLayerTrackFeatures].forEach(
      feature => {
        const props = (feature && feature.properties) || EMPTY_OBJECT;
        const id =
          props.EntityId || props.featureId || props.trackId || feature.id;
        const key = String(id || '');
        if (key !== '' && seenIds.has(key)) return;
        if (key !== '') seenIds.add(key);
        combined.push(feature);
      }
    );
    return combined;
  }
);
const getSelectedLayers = state => state.layer.selectedLayers || EMPTY_ARRAY;
const getTimelineResults = state => state.timeline.results || EMPTY_ARRAY;
const getQuerySelectedAgents = state => state.query.agents || EMPTY_ARRAY;
const getQuerySelectedConcepts = state => state.query.concepts || EMPTY_ARRAY;
const getSelectedItem = state => state.timeline.selectedItem || EMPTY_OBJECT;
const getQueryNorth = state => state.query.north;
const getQueryEast = state => state.query.east;
const getQuerySouth = state => state.query.south;
const getQueryWest = state => state.query.west;
const getQueryStart = state => state.query.start;
const getQueryEnd = state => state.query.end;

const mapStateToProps = createSelector(
  getOntology,
  getDataSources,
  getAgents,
  getShowInactiveAgents,
  getAgentRegistry,
  getCurrentUser,
  getSelectedLayers,
  getAgentLayerFeatures,
  getTrackLayerFeatures,
  getTimelineResults,
  getQuerySelectedAgents,
  getQuerySelectedConcepts,
  getSelectedItem,
  getQueryNorth,
  getQueryEast,
  getQuerySouth,
  getQueryWest,
  getQueryStart,
  getQueryEnd,
  (
    ontology,
    dataSources,
    agents,
    showInactiveAgents,
    agentRegistry,
    currentUser,
    selectedLayers,
    agentFeatures,
    trackFeatures,
    timelineResults,
    querySelectedAgents,
    querySelectedConcepts,
    selectedItem,
    queryNorth,
    queryEast,
    querySouth,
    queryWest,
    queryStart,
    queryEnd
  ) => {
    const displayAgents = buildDisplayAgents(
      agents,
      showInactiveAgents,
      agentFeatures,
      agentRegistry
    );

    return {
      ontology,
      dataSources,
      agents: displayAgents,
      currentUser,
      selectedLayers,
      agentFeatures,
      trackFeatures,
      timelineResults,
      querySelectedAgents,
      querySelectedConcepts,
      selectedItem,
      queryNorth,
      queryEast,
      querySouth,
      queryWest,
      queryStart,
      queryEnd
    };
  }
);

const mapDispatchToProps = {
  getTimeline: actions.timeline.getTimeline,
  setSelectedConcepts: actions.query.setSelectedConcepts,
  setMode: actions.query.setMode,
  setSelectedDataSources: actions.query.setSelectedDataSources,
  setSelectedAgents: actions.query.setSelectedAgents,
  setSelectedLayers: actions.layer.setSelectedLayers,
  getTracksForCurrentFilters: actions.user.getTracksForCurrentFilters,
  setSelectedItem: actions.timeline.setSelectedItem,
  clearSelectedItem: actions.timeline.clearSelectedItem
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
